import { Pipe, PipeTransform } from '@angular/core';
import { CreatureSortType } from '../enums/creature-sort.type';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'creatureSortType',
  standalone: true,
})
export class CreatureSortTypePipe implements PipeTransform {

  constructor(private readonly translateService: TranslateService) {

  }

  transform(sortBy: CreatureSortType | null): string {
    if (sortBy === null) {
      return 'Unknown';

    }

    switch (sortBy) {
      case CreatureSortType.PriceAsc:
        return this.translateService.instant('list_creature.sort_options.price');
      case CreatureSortType.PriceDesc:
        return this.translateService.instant('list_creature.sort_options.price_desc');
      case CreatureSortType.LevelAsc:
        return this.translateService.instant('list_creature.sort_options.level');
      case CreatureSortType.LevelDesc:
        return this.translateService.instant('list_creature.sort_options.level_desc');
      case CreatureSortType.HpAsc:
        return this.translateService.instant('list_creature.sort_options.hp');
      case CreatureSortType.HpDesc:
        return this.translateService.instant('list_creature.sort_options.hp_desc');
      case CreatureSortType.RarityAsc:
        return this.translateService.instant('list_creature.sort_options.rarity');
      case CreatureSortType.RarityDesc:
        return this.translateService.instant('list_creature.sort_options.rarity_desc');
      case CreatureSortType.TokenIdAsc:
        return this.translateService.instant('list_creature.sort_options.token_id');
      case CreatureSortType.TokenIdDesc:
        return this.translateService.instant('list_creature.sort_options.token_id_desc');
      default:
        return this.translateService.instant('list_creature.sort_options.unknown');
    }
  }
}